import React from 'react';
import logo from '../../img/headerLogo.svg'
import './index.scss'
const Header = () => {
    return (
        <div className={'headerContainer'}>
            <img src={logo}/>
        </div>
    );
};

export default Header;
